export function obterQueryString() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => {
            if (prop == 'getAll') {
                const array = []

                for (const iterator of searchParams.keys()) {
                    array[iterator] = searchParams.getAll(iterator);
                }

                return array;
            }

            return searchParams.get(prop);
        }
    });

    return params;
}
